import { useEffect, useState } from "react"
import { Alert, Box, CircularProgress, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material"

const API_URL = `${window.location.origin}/api`
const dataPt = valor => valor ? new Date(`${valor}T00:00:00`).toLocaleDateString("pt-BR") : "—"

export default function HistoricoAlocacoes({ equipamentoId }) {
  const [dados, setDados] = useState(null)
  const [erro, setErro] = useState("")
  useEffect(() => {
    let ativo = true
    fetch(`${API_URL}/equipamentos/${equipamentoId}/historico-alocacoes`)
      .then(r => r.json()).then(r => { if (ativo) r.sucesso ? setDados(r.dados) : setErro(r.erro || "Falha ao carregar histórico") })
      .catch(e => { if (ativo) setErro(`Falha ao carregar histórico: ${e.message}`) })
    return () => { ativo = false }
  }, [equipamentoId])
  return <Paper sx={{ p: 3 }}>
    <Typography variant="h6" sx={{ mb: 2 }}>Histórico de alocação por obra</Typography>
    {erro && <Alert severity="error">{erro}</Alert>}
    {!dados && !erro && <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}><CircularProgress size={24} /></Box>}
    {dados && <>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>Equipamento {dados.equipamento.codigo}</Typography>
      <Box sx={{ overflowX: "auto" }}><Table size="small" aria-label="Histórico de alocação por obra"><TableHead><TableRow><TableCell>Obra / almoxarifado</TableCell><TableCell>Primeira entrada</TableCell><TableCell>Última saída</TableCell><TableCell>Última reentrada</TableCell><TableCell align="right">Total de dias</TableCell><TableCell>Situação</TableCell></TableRow></TableHead>
        <TableBody>{dados.periodos.length ? dados.periodos.map(p => <TableRow key={p.id}><TableCell>{p.almoxarifado?.nome || "—"}</TableCell><TableCell>{dataPt(p.data_entrada)}</TableCell><TableCell>{dataPt(p.data_saida)}</TableCell><TableCell>{dataPt(p.data_reentrada)}</TableCell><TableCell align="right">{p.dias}</TableCell><TableCell>{p.situacao === "ALOCADO" ? "Alocado" : "Encerrado"}</TableCell></TableRow>) : <TableRow><TableCell colSpan={6} align="center">Nenhum período registrado.</TableCell></TableRow>}</TableBody>
      </Table></Box>
    </>}
  </Paper>
}
